// extracted by css-extract-rspack-plugin
export default {"auxIcon":"auxIcon-Ugz3eC"};